import React from 'react';
import './Services.css';

// Import required components
import { Heading, Service } from '../../../components';
import { services } from '../../../constants';


const Services = () => { 

  return (
    <section className='services'>

      {/* Section heading */}
      <Heading title={'our services'} subTitle={'what we offer'} />

      <div className='box-container'>

        {/* Map over the services array to render each service */}
        {services.map((service) => { 
          return (
            <Service key={service.id} service={service} />
          );
        })}

      </div>

    </section>
  )
}

export default Services